module.exports = __webpack_public_path__ + "img/271.3b32f503.png";